import { render, staticRenderFns } from "./OverridePriceModal.vue?vue&type=template&id=8451dcc8&scoped=true"
import script from "./OverridePriceModal.vue?vue&type=script&lang=js"
export * from "./OverridePriceModal.vue?vue&type=script&lang=js"
import style0 from "./OverridePriceModal.vue?vue&type=style&index=0&id=8451dcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8451dcc8",
  null
  
)

export default component.exports